import { useSearchParams } from 'react-router';

import { setLoginError } from '../../store/localStorageHelpers/loginErrorHelper';
import { isLoggedInWithBentleyToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { BentleyLogout } from '../logout/BentleyLogout';
import { Logout } from '../logout/Logout';

export const ErrorRedirect = () => {
    const [searchParams] = useSearchParams();
    const loginError = searchParams.get('error');
    // Using search params as a fallback due to some use cases where the licenses are cleared so the
    // `isLoggedInWithBentleyToken()` method returns false, but we've directly added the `bentley_token`
    // parameter to the search params, meaning the user may still be logged in.
    const isLoggedInWithBentley =
        isLoggedInWithBentleyToken() || searchParams.get('bentley_token') === 'true';
    if (loginError) {
        setLoginError(loginError);
    }
    return isLoggedInWithBentley ? <BentleyLogout /> : <Logout />;
};
